import { currencyFormatter } from '@assetmark/utilities';
import React from 'react';
import { TOtherIncome } from '../../models/other-income';
import { TOtherIncomeSourceType } from '../../models/other-income-source-type.model';
import OtherIncomeSourceTypeDropdown from './other-income-source-type-dropdown';
import styles from './other-income-source.module.css';

export interface TOtherIncomeSourceProps {
  otherIncomeSource?: TOtherIncome[];
  addOtherIncome?: (event: any) => void;
  removeOtherIncome?: (index: number) => void;
  options?: TOtherIncomeSourceType[];
  onChange?: (event: any, otherIncomeItem: TOtherIncome, index: number) => void;
  onBlur?: (event: any) => void;
  onKeyPress?: (event: any) => void;
  showError?: boolean;
  errorText?: string;
  hideErrorText?: string;
  type?: string;
  addSourceBtnDisabled?: boolean;
  name: string;
}

const OtherIncomeSource: React.FC<TOtherIncomeSourceProps> = ({
  name,
  otherIncomeSource = [],
  addOtherIncome,
  removeOtherIncome,
  options,
  onChange,
  onBlur,
  showError,
  hideErrorText,
  errorText,
  addSourceBtnDisabled,
  onKeyPress,
}) => {
  const validationFailed = showError && errorText && errorText.length > 0;
  return (
    <div className={`${styles.input_container}`}>
      {otherIncomeSource &&
        otherIncomeSource.map((item: TOtherIncome, index) => (
          <div className={`row ${styles.mt20}`} key={index}>
            <div
              className={`col-sm-5 ${styles.label_text} ${styles.displayFlex}`}
            >
              $
              <input
                type="text"
                className={`${styles.amount_text} ${styles.underline_input} ${styles.input_text} mt-2 mr-0"`}
                placeholder=""
                value={currencyFormatter(item.MonthlyIncome)}
                name={'monthlyIncome'}
                onChange={(event) => onChange(event, item, index)}
                onBlur={onBlur}
                disabled={false}
                onKeyPress={onKeyPress}
              />
            </div>
            <div className={`col-sm-6 ${styles.label_text}`}>
              <OtherIncomeSourceTypeDropdown
                name={'otherIncomeSourceType'}
                value={item.IncomeSourceTypeId || 0}
                options={options}
                onChange={(event) => onChange(event, item, index)}
                isDisabled={false}
                className={''}
                smallDropdown={true}
              />
            </div>
            <div
              className={`col-sm-1 ${styles.label_text} ${styles.text_right}`}
            >
              {index > 0 ? (
                <button
                  className={`${styles.remove_item} mt-2`}
                  onClick={(e) => removeOtherIncome(index)}
                >
                  {' '}
                  X{' '}
                </button>
              ) : (
                <div>&nbsp; </div>
              )}
            </div>
          </div>
        ))}

      <div className={`row ${styles.mt20}`}>
        <div className={`col-sm-11 ${styles.label_text} ${styles.text_right}`}>
          <button
            className={
              addSourceBtnDisabled
                ? `${styles.add_source} ${styles.disabled}`
                : `${styles.add_source}`
            }
            onClick={addOtherIncome}
            disabled={addSourceBtnDisabled}
          >
            + Add Source{' '}
          </button>
        </div>
      </div>
      {validationFailed && !hideErrorText && (
        <div className="validation-error text">{errorText}</div>
      )}
    </div>
  );
};

export default OtherIncomeSource;
